import {SocialType} from 'components/SocialButton';
import {Moment} from 'moment';
import {PreviewObject} from 'types';

export enum GenderType {
  Male = 'male',
  Female = 'female',
}

export interface ProfileContacts {
  phone?: string,
  email?: string,
}

export interface ProfileSocials {
  instagram?: string,
  telegram?: string,
  vkontakte?: string,
}

export interface ProfileUser {
  name: string;
  surname?: string;
  gender?: GenderType;
  nickname: string;
  avatar?: PreviewObject;
  video?: string;
  info?: ProfileInfo;
  contacts?: ProfileContacts;
  socials?: ProfileSocials;
  preferredCommunication?: ProfileSocialItem | ProfileContacts;
}

export interface ProfileInfo {
  about?: string,
  birthday?: Moment,
  city?: string,
  education?: string,
  job?: string
}

export interface ProfileViewProps {
  name: string;
  surname: string;
  nickname: string;
  gender?: GenderType;
  avatar?: PreviewObject;
  video: string;
  info: ProfileInfo;
  contacts: ProfileContacts;
  socials: ProfileSocials;
  preferredCommunication?: ProfileSocialItem | ProfileContacts;
}

export interface ProfileSocialItem {
  type: SocialType,
  value: string,
}
